import { render, staticRenderFns } from "./actv1.vue?vue&type=template&id=3c1a5867&scoped=true&"
import script from "./actv1.vue?vue&type=script&lang=js&"
export * from "./actv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a5867",
  null
  
)

export default component.exports